module.exports = __webpack_public_path__ + "img/nature@2x.937078d.jpg";